import { useState } from "react"

export const useHeldValue = <T>(value: T, holding: boolean): T => {
  const [held, setHeld] = useState(value)
  if (!holding && !Object.is(held, value)) setHeld(value)
  return holding ? held : value
}
